import { getVariantPrice, isVariantInStock } from "@/lib/format";

export function norm(value) {
  return String(value || "")
    .trim()
    .toLowerCase();
}

export function productText(product) {
  return [
    product?.title,
    product?.subtitle,
    product?.description,
    product?.handle,

    product?.metadata?.department,
    product?.metadata?.category,
    product?.metadata?.subcategory,
    product?.metadata?.brand,

    ...(product?.categories || []).map((category) => category.name),

    ...(product?.tags || []).map((tag) => tag.value),
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
}

export function productBrand(product) {
  const direct = product?.metadata?.brand || product?.metadata?.Brand;

  if (typeof direct === "string" && direct.trim()) {
    return direct.trim();
  }

  const tagged = (product?.tags || []).find((tag) =>
    /^brand\s*[:\-]/i.test(tag?.value || ""),
  );

  if (tagged?.value) {
    return tagged.value.replace(/^brand\s*[:\-]\s*/i, "").trim();
  }

  return product?.collection?.title || "";
}

export function variantPrice(product) {
  const values = (product?.variants || [])
    .map(getVariantPrice)
    .filter((value) => value !== null && value !== undefined)
    .map(Number);

  return values.length ? Math.min(...values) : null;
}

export function productInStock(product) {
  return (product?.variants || []).some(isVariantInStock);
}

export function metadataValues(product, key) {
  const value = product?.metadata?.[key];

  if (Array.isArray(value)) {
    return value.map(String).filter(Boolean);
  }

  if (typeof value === "string") {
    return value
      .split(/[|,]/)
      .map((item) => item.trim())
      .filter(Boolean);
  }

  return [];
}

export function matchesCategory(product, category) {
  if (!category) {
    return true;
  }

  const target = norm(category);

  const names = [
    product?.metadata?.category,

    ...(product?.categories || []).map((item) => item.name),
  ].map(norm);

  if (
    names.some(
      (name) =>
        name === target || name.includes(target) || target.includes(name),
    )
  ) {
    return true;
  }

  return productText(product).includes(target);
}

export function matchesChip(product, chip) {
  if (!chip || chip === "All") {
    return true;
  }

  const target = norm(chip);

  const candidates = [
    product?.metadata?.subcategory,
    product?.metadata?.sub_category,
    product?.metadata?.chip,

    ...(product?.tags || []).map((item) => item.value),
  ].map(norm);

  if (candidates.some((value) => value === target || value.includes(target))) {
    return true;
  }

  return productText(product).includes(target);
}
